import { initPerformanceAnalytics } from '@stitch-fix/sf-next';
import { initDatadogLogger } from './utils/loggers/browser';

initDatadogLogger();
initPerformanceAnalytics({
  sampleRate: 100,
});
